<template>
  <div>
    <div
      v-if="step == 'SAUDE'"
      class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
    >
      <MenuCheers />
    </div>
    <div
      v-if="step == 'INFORMACOES'"
      class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
    >
      <Information />
    </div>
    <div
      v-if="step == 'AGENDA'"
      class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
    >
      <MenuSchedule :resident_id="resident.id" />
    </div>
    <div
      v-if="step == 'PASTA'"
      class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
    >
      <MenuFolder :resident_id="resident.id" />
    </div>
    <div
      v-if="step == 'ROTINA_DIARIA'"
      class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
    >
      <MenuDailyRoutine
        :type_of_food="type_of_food"
        v-on:checked="$emit('getDatesChecksPending')"
      />
    </div>
    <div
      v-if="step == 'MEDICO'"
      class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
    >
      <MenuDoctor :resident="resident" />
    </div>
    <div
      v-if="step == 'ENFERMEIRO'"
      class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
    >
      <MenuNurse />
    </div>
    <div
      v-if="step == 'ESTOQUE'"
      class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
    >
      <MenuStock
        :resident="resident"
        @handleToResident="$emit('handleToResident')"
      />
    </div>
    <div
      v-if="step == 'ENTREGA_DE_PRODUTOS'"
      class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
    >
      <MenuList />
    </div>
    <div
      v-if="step == 'SEMIOLOGIA'"
      class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
    >
      <Semiology
        v-on:update="$emit('getSemiologiesPending')"
        v-on:delete="$emit('getSemiologiesPending')"
      />
    </div>
    <div
      v-if="step == 'NUTRICIONISTA'"
      class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
    >
      <MenuNutritionist />
    </div>
    <div
      v-if="step == 'FISIOTERAPEUTA'"
      class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
    >
      <MenuPhysiotherapist />
    </div>
    <div
      v-if="step == 'PSICOLOGO'"
      class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
    >
      <MenuPsychologist />
    </div>
    <div
      v-if="step == 'FONOAUDIOLOGO'"
      class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
    >
      <MenuSpeechTherapist />
    </div>
    <div
      v-if="step == 'TERAPEUTA_OCUPACIONAL'"
      class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
    >
      <MenuOccupationalTherapist />
    </div>
    <div
      v-if="step == 'DENTISTA'"
      class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
    >
      <MenuDentist />
    </div>
    <div
      v-if="step == 'MUSICOTERAPIA'"
      class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
    >
      <MenuMusicTherapy />
    </div>
    <div
      v-if="step == 'ASSISTENTE_SOCIAL'"
      class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
    >
      <MenuSocialWorker />
    </div>
    <div
      v-if="step == 'EDUCADOR_FISICO'"
      class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
    >
      <MenuPhysicalEducator />
    </div>
    <div
      v-if="step == 'EDUCADORES_E_PEDAGOGOS'"
      class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
    >
      <MenuEducatorsAndPedagogues />
    </div>
    <div
      v-if="step == 'PEDIDOS'"
      class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
    >
      <MenuOrder :resident="resident" />
    </div>
    <div
      v-if="step == 'VERIFICACAO_DE_PENDENCIAS'"
      class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
    >
      <MenuPendingVerification
        :resident="resident"
        @pendingVerification="$emit('pendingVerification', $event)"
      />
    </div>
    <div
      v-if="step == 'FINANCEIRO'"
      class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
    >
      <MenuFinancial :resident="resident" />
    </div>
    <div
      v-if="step == 'CONTA_CORRENTE'"
      class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
    >
      <MenuAccount :resident="resident" />
    </div>
  </div>
</template>

<script>
import Information from "./Information";

import MenuSchedule from "./MenuSchedule";

import MenuFolder from "./MenuFolder";

import MenuCheers from "./MenuCheers";

import MenuDoctor from "./MenuDoctor";

import MenuNurse from "./MenuNurse";

import MenuDailyRoutine from "./MenuDailyRoutine";

import MenuNutritionist from "./MenuNutritionist";

import MenuPhysiotherapist from "./MenuPhysiotherapist";

import MenuPsychologist from "./MenuPsychologist";

import MenuSpeechTherapist from "./MenuSpeechTherapist";

import MenuOccupationalTherapist from "./MenuOccupationalTherapist";

import MenuDentist from "./MenuDentist";

import MenuMusicTherapy from "./MenuMusicTherapy";

import MenuSocialWorker from "./MenuSocialWorker";

import MenuPhysicalEducator from "./MenuPhysicalEducator";

import MenuEducatorsAndPedagogues from "./MenuEducatorsAndPedagogues";

import MenuOrder from "./menu-order.vue";

import MenuPendingVerification from "./menu-pending-verification.vue";

import MenuFinancial from "./MenuFinancial";

import MenuAccount from "./menu-account";

import MenuStock from "./MenuStock";

import MenuList from "./MenuList";

import Semiology from "./Semiology";

import routes from "../../routes";

import permission from "../../lib/permission";

export default {
  name: "RegistrationData",

  components: {
    Information,
    MenuSchedule,
    MenuFolder,
    MenuCheers,
    MenuDoctor,
    MenuNurse,
    MenuDailyRoutine,
    MenuStock,
    MenuList,
    Semiology,
    MenuNutritionist,
    MenuPhysiotherapist,
    MenuPsychologist,
    MenuSpeechTherapist,
    MenuOccupationalTherapist,
    MenuDentist,
    MenuMusicTherapy,
    MenuSocialWorker,
    MenuPhysicalEducator,
    MenuEducatorsAndPedagogues,
    MenuOrder,
    MenuPendingVerification,
    MenuFinancial,
    MenuAccount,
  },

  props: {
    resident: { type: [Object, String, Boolean, Number] },
    step: { type: [String] },
    width: { type: [String, Number] },
    type_of_food: { type: [String, Number] },
  },

  data() {
    return {};
  },

  created() {
    this.retrieve();
  },

  methods: {
    permission,

    handleStep(step) {
      let newTab = {
        INFORMACOES: "informations",
        AGENDA: "schedules",
        PASTA: "folders",
        ROTINA_DIARIA: "check",
        SAUDE: "cheers",
        MEDICO: "doctor",
        ENFERMEIRO: "nurse",
        ESTOQUE: "stock",
        ENTREGA_DE_PRODUTOS: "list",
        SEMIOLOGIA: "semiology",
        NUTRICIONISTA: "nutritionist",
        FISIOTERAPEUTA: "physiotherapist",
        PSICOLOGO: "psychologist",
        FONOAUDIOLOGO: "speech_therapist",
        ASSISTENTE_SOCIAL: "social_worker",
        EDUCADOR_FISICO: "physical_educator",
        EDUCADORES_E_PEDAGOGOS: "educators_and_pedagogues",
        PEDIDOS: "order",
        SERVICO: "service",
        HOSPEDAGEM_FINANCEIRO: "hosting_financial",
        FINANCEIRO: "financial",
        CONTA_CORRENTE: "account",
        VERIFICACAO_DE_PENDENCIAS: "pending_verification",
      }[step];

      let { tab } = routes.history.current.query;

      if (tab != newTab) {
        routes.replace({ query: { tab: newTab } });
      }

      this.$emit("handleStep", step);
    },
    retrieve() {
      const { id } = routes.history.current.params;

      this.resident_id = id;
    },
  },
};
</script>
